import { useState } from "react";
import { Chat, Channel, Window, MessageList, MessageComposer } from "stream-chat-react";
import { useAuth } from "@/context/AuthContext";
import { Timer } from "lucide-react";
import "stream-chat-react/dist/css/index.css";

export function LiveChat({ chat, channel, moderator = false }) {
  const { user } = useAuth();
  const readOnly = user?.role === "external_premium_reviewer";
  const [slow, setSlow] = useState(Boolean(channel.data?.cooldown));
  const toggleSlow = async () => {
    if (slow) await channel.disableSlowMode();
    else await channel.enableSlowMode(30);
    setSlow(!slow);
  };
  return (
    <div data-testid="live-chat" className="peeping-chat flex h-[420px] flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#0c0a10] lg:h-full">
      {moderator && (
        <div className="flex items-center justify-between border-b border-white/10 px-3 py-2 text-xs">
          <span className="text-[#a7a0af]">You moderate this chat · tap and hold (or hover) a message to delete or mute</span>
          <button onClick={toggleSlow} data-testid="chat-slow-mode" className={`flex items-center gap-1 rounded-full border px-2 py-1 ${slow ? "border-[#d42be8] text-[#f0a8fa]" : "border-white/15"}`}>
            <Timer size={12} /> Slow mode {slow ? "on" : "off"}
          </button>
        </div>
      )}
      <Chat client={chat} theme="str-chat__theme-dark">
        <Channel channel={channel}>
          <Window>
            <MessageList />
            {readOnly ? <p data-testid="chat-readonly" className="border-t border-white/10 px-3 py-2 text-xs text-[#a7a0af]">Reviewer access is read-only — chat is view only.</p> : <MessageComposer />}
          </Window>
        </Channel>
      </Chat>
    </div>
  );
}
